import React from 'react';
import { Router, Link, hashHistory } from 'react-router';
import SwipeableViews from 'react-swipeable-views';

import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import {Tabs, Tab} from 'material-ui/Tabs';

const Login = React.createClass({
	getInitialState: function() {
		return {
			headerTitle: 'Prop Quiz',
			index: 0,
			username: '',
			password: '',
			error: ''
		}
	},
	_changeView: function() {
		if (this.state.index == 0) {
			this.setState({
				index: 1,
				error: '',
				username: '',
				password: ''
			});
		} else {
			this.setState({
				index: 0,
				error: '',
				username: '',
				password: ''
			});
		}
	},
	_handleUsername: function(val) {
		this.setState({
			username: val,
			error: ''
		})
	},
	_handlePassword: function(val) {
		this.setState({
			password: val,
			error: ''
		})
	},
	_submitLogin: function(e) {
		e.preventDefault();

		let data = {
			username: this.state.username.trim(),
			password: this.state.password
		}

		let request = new XMLHttpRequest;
		request.open('PUT', '/api/v2/users/login/');
		request.setRequestHeader('Content-Type', 'application/json');
		request.send(JSON.stringify(data));
		request.onreadystatechange = function(){
			if (request.readyState == 4) {
				if (request.status == 201) {
					const loginData = JSON.parse(request.responseText);
					localStorage.setItem('token', loginData.JWT);
					localStorage.setItem('username', loginData.user.username)
					hashHistory.push('/');
				} else if (request.status == 400) {
					this.setState({
						error: 400
					});
				}
			}
		}.bind(this);

	},
	_submitUserInfo: function() {
		let data = {
			username: this.state.username.trim(),
			password: this.state.password
		}
		let request = new XMLHttpRequest;
		request.open('POST', '/api/v2/users');
		request.setRequestHeader('Content-Type', 'application/json');
		request.send(JSON.stringify(data));
		request.onreadystatechange = function(){
			if (request.readyState == 4) {
				if (request.status == 201) {
					const loginData = JSON.parse(request.responseText);
					localStorage.setItem('token', loginData.JWT);
					localStorage.setItem('username', loginData.user.username)
					hashHistory.push('/');
				} else if (request.status == 409) {
					this.setState({
						error: 409
					});
				}
			}
		}.bind(this);
	},
	render: function() {
		const style = {
			marginTop: '30px',
			color: '#fff',
			width: '100%',
		};
		return (
			<div className="view">
				<header className="main">
					<h1>{this.state.headerTitle}</h1>
				</header>
				<Tabs
					value={this.state.index}
					onChange={this._changeView}
				>
					<Tab label="Sign In" value={0} />
					<Tab label="Sign Up" value={1} />
				</Tabs>
				<SwipeableViews
					index={this.state.index}
					onChangeIndex={this._changeView}
				>
					<div className="login">
						<LoginFields
							username={this.state.username}
							password={this.state.password}
							handleUsername={this._handleUsername}
							handlePassword={this._handlePassword}
							error={this.state.error}
						/>
						<FlatButton
							label="Sign In"
							onClick={this._submitLogin}
							backgroundColor="#82CCC8"
							hoverColor="#7CCEC7"
							style={style}
						/>
					</div>
					<div className="login">
						<LoginFields
							username={this.state.username}
							password={this.state.password}
							handleUsername={this._handleUsername}
							handlePassword={this._handlePassword}
							error={this.state.error}
						/>
						<FlatButton
							label="Sign Up"
							onClick={this._submitUserInfo}
							backgroundColor="#82CCC8"
							hoverColor="#7CCEC7"
							style={style}
						/>
					</div>
				</SwipeableViews>
			</div>
		)
	}
});

const LoginFields = React.createClass({
	_handleUsername: function(e) {
		this.props.handleUsername(e.target.value);
	},
	_handlePassword: function(e) {
		this.props.handlePassword(e.target.value);
	},
	render: function() {
		if (!this.props.error) {
			return (
				<div>
					<TextField
						hintText="Enter username"
						floatingLabelText="Username"
						onChange={this._handleUsername}
						value={this.props.username}
						fullWidth={true}
					/><br />
					<TextField
						hintText="Enter password"
						floatingLabelText="Password"
						type="password"
						onChange={this._handlePassword}
						value={this.props.password}
						fullWidth={true}
					/>
				</div>
			)
		} else if (this.props.error == 409) {
			return (
				<div>
					<TextField
						hintText="Enter username"
						floatingLabelText="Username"
						errorText="This username already exists"
						onChange={this._handleUsername}
						value={this.props.username}
						fullWidth={true}
					/><br />
					<TextField
						hintText="Enter password"
						floatingLabelText="Password"
						type="password"
						onChange={this._handlePassword}
						value={this.props.password}
						fullWidth={true}
					/>
				</div>
			)
		} else {
			return (
				<div>
					<TextField
						hintText="Enter username"
						errorText=" "
						floatingLabelText="Username"
						onChange={this._handleUsername}
						value={this.props.username}
						fullWidth={true}
					/><br />
					<TextField
						hintText="Enter password"
						errorText="Login is incorrect"
						floatingLabelText="Password"
						type="password"
						onChange={this._handlePassword}
						value={this.props.password}
						fullWidth={true}
					/>
				</div>
			)
		}
	}
});

export default Login;


// WEBPACK FOOTER //
// ./src/views/login.jsx